import { Component } from '@angular/core';

@Component({
  selector: 'app-wedding',
  templateUrl: './wedding.component.html',
  styleUrls: ['./wedding.component.scss']
})
export class WeddingComponent {
  readonly email = 'twogetherflower@gmail.com';
  readonly inquiryHref = `mailto:${this.email}?subject=${encodeURIComponent('Esküvői virágdekoráció – ajánlatkérés')}`;
  readonly packages = [
    {
      name: 'Essence', price: '149 990', subtitle: 'A személyes pillanatokhoz',
      items: ['Menyasszonyi csokor és dobócsokor', 'Kitűzők és élővirágos karkötők', 'Szülőköszöntő csokrok vagy virágboxok', 'Virágok a koszorúslányoknak']
    },
    {
      name: 'Signature', price: '349 990', subtitle: 'Az ünnepi asztalokhoz is',
      items: ['Az Essence csomag személyes virágai', 'Főasztaldísz', 'Szezonális virágok vázákban a vendégasztalokra', 'Virágdísz a szertartásvezető asztalára']
    },
    {
      name: 'Prestige', price: '749 990', subtitle: 'A teljes virágélményhez',
      items: ['Személyes csokrok és virágkiegészítők', 'Tűzött asztali kompozíciók', 'A bevonulás virágdekorációja', 'A boldogságkapu díszítése']
    }
  ];
  readonly links = [
    { label: 'Instagram', url: 'https://instagram.com/twogetherflowers' },
    { label: 'Facebook', url: 'https://facebook.com/twogetherflowers' },
    { label: 'TikTok', url: 'https://www.tiktok.com/@twogetherflower' },
    { label: 'Weboldal', url: 'https://www.twogetherflower.hu' },
    { label: 'Webshop', url: 'https://shop.twogetherflower.hu' },
    { label: 'Wolt', url: 'https://wolt.com/hu/hun/budapest/venue/dd-twogether-flowers-and-more' },
    { label: 'Google értékelés', url: 'https://g.page/r/CU3IJBgEkVUzEBM/review' }
  ];
  readonly contactVcardUrl = `data:text/vcard;charset=utf-8,${encodeURIComponent([
    'BEGIN:VCARD', 'VERSION:3.0', 'N:D&D Twogether - Flowers and more;;;',
    'FN:D&D Twogether - Flowers and more', 'ORG:D&D Twogether - Flowers and more',
    'TEL;TYPE=CELL:+36300121051', 'EMAIL:twogetherflower@gmail.com',
    'URL:https://www.twogetherflower.hu',
    'ADR;TYPE=WORK:;;Cserhalom utca - Mura utca sarka;Budapest;;1138;Hungary', 'END:VCARD'
  ].join('\r\n'))}`;
}
